import { useUserAccess } from './useUserAccess';

export const useSuperAdmin = () => {
  const { tier, isLoading } = useUserAccess();
  const isSuperAdmin = tier === 'super_admin';

  return {
    isSuperAdmin,
    isLoading,
  };
};